/** Escapes a string for safe use in an HTML attribute or text node. */
function escapeHtml(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

/**
 * Wraps `[label]` placeholders in variable spans so the editor highlights them.
 * Populated variables carry their value; unfilled ones keep the `[label]` marker.
 */
export function applyVariableValues(html, values) {
  if (!html) return html;
  return html.replace(/\[([^\]]+)\]/g, function (_match, rawLabel) {
    var label = rawLabel.trim();
    var value = values[label];
    var hasValue = value !== undefined && value !== "";
    var valueAttr = hasValue ? " data-value=\"".concat(escapeHtml(value), "\"") : "";
    var text = escapeHtml(hasValue ? value : "[".concat(label, "]"));
    return "<span data-variable-node=\"true\" data-label=\"".concat(escapeHtml(label), "\"").concat(valueAttr, ">").concat(text, "</span>");
  });
}

/** Replaces variable spans with their plain value (or `[label]`) for saving. */
export function stripVariableValues(html) {
  if (!html || typeof document === "undefined") return html;
  var doc = new DOMParser().parseFromString(html, "text/html");
  doc.querySelectorAll('span[data-variable-node="true"]').forEach(function (span) {
    var _span$getAttribute;
    var value = span.getAttribute("data-value");
    var label = (_span$getAttribute = span.getAttribute("data-label")) !== null && _span$getAttribute !== void 0 ? _span$getAttribute : "";
    span.replaceWith(document.createTextNode(value !== null && value !== void 0 ? value : "[".concat(label, "]")));
  });
  return doc.body.innerHTML;
}

/** Converts a path-keyed populate response to a label-keyed map using the variable definitions. */
export function toLabelKeyedValues(pathValues, variables) {
  var result = {};
  variables.forEach(function (variable) {
    var value = pathValues[variable.key];
    if (value !== undefined) result[variable.label] = value;
  });
  return result;
}